import React from 'react';
import { useDevice } from './DeviceContext';
import { Smartphone, Tablet, Monitor } from 'lucide-react';

/**
 * Floating toolbar top-right that toggles the prototype's device preview.
 *
 * Only rendered on employee-side routes (admin is desktop-only). Positioned
 * fixed so it's always reachable; offset to the right of the prototype nav.
 */
const OPTIONS = [
  { id: 'mobile', label: 'Mobile', icon: Smartphone, width: '390px' },
  { id: 'tablet', label: 'Tablet', icon: Tablet, width: '768px' },
  { id: 'desktop', label: 'Desktop', icon: Monitor, width: 'auto' },
];

const DeviceSwitcher = () => {
  const { device, setDevice } = useDevice();
  return (
    <div className='fixed top-4 right-4 z-50 flex items-center gap-1 p-1 rounded-xl bg-card border border-border shadow-md'>
      {OPTIONS.map((opt) => {
        const Icon = opt.icon;
        const active = device === opt.id;
        return (
          <button
            key={opt.id}
            type='button'
            onClick={() => setDevice(opt.id)}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-[12px] font-medium transition-colors ${
              active
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            title={`Preview at ${opt.label} (${opt.width})`}>
            <Icon size={13} strokeWidth={1.75} />
            <span className='hidden sm:inline'>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default DeviceSwitcher;
